import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Discover from "../assets/images/budget.svg";
import Track from "../assets/images/goals.svg";
import Shop from "../assets/images/heart-fill.svg";
import smallLogo from '../assets/images/small-logo.svg'
const SeeHowCanHelp = () => {
  return (
    <div className="why-pre-qualified common-padding">
        <Container>
            <div className="common-header text-center">
              <h2>See how  <img className="ps-1 pe-2" src={smallLogo} alt="" />can help</h2>
              <p>Discover the powerful tools and features that make finding, buying, or selling properties easier and more efficient than ever.</p>
            </div>
            <Row className="g-4 justify-content-center">
                <Col md={4}>
                <Card>
                    <img src={Discover} alt=""></img>
                    <h5>Discover</h5>
                    <p className="mb-0">
                    Get a budget estimate based on your finances and live interest rates powered by Real Estate Home Loans.
                    </p>
                </Card>
                </Col>
                <Col md={4}>
                    <Card>
                        <img src={Track} alt=""></img>
                        <h5>Track</h5>
                        <p className="mb-0">
                        See real-time updates as interest rates shift and watch your home budget change over time.
                        </p>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card>
                        <img src={Shop} alt=""></img>
                        <h5>Shop</h5>
                        <p className="mb-0">
                        Know which homes fall into your budget with a personalized shopping experience across Real Estate.
                        </p>
                    </Card>
                </Col>
            </Row>
        </Container>
    </div>
  );
};

export default SeeHowCanHelp;
